import React from 'react';
import SupportServicesTable from './SupportServicesTable';

const SupportServicesCategory = ({data}) => {
  return (
        <SupportServicesTable data={data} />
  );
};

export default SupportServicesCategory;
